import classNames from 'classnames';

import { setupForDark } from '@theme';

interface InfoBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  gap?: string;
}

const InfoBox = ({ children, className, gap = 'gap-xs', ...props }: InfoBoxProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col',
        'rounded-md p-md',
        setupForDark('bg-card-tertiary'),
        gap,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default InfoBox;
